module.exports = __webpack_public_path__ + "img/icon-ai-xiaojie-line@3x.c6157fad.png";